import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import SchoolForm from '../../school/school.form';
import { schoolApi } from "../../school/school.queries";

export default function SchoolStep(props) {
	const useSave = schoolApi.useSave();
	const [school, setSchool] = useState(props.school);

	const saveSchool = async () => {
		const result = await useSave.mutateAsync(school);
		props?.onNext?.();
	}

	return (
		<React.Fragment>
			<Paper sx={props.sx}>
				<Typography variant="h3">What is the name of your school?</Typography>
				<SchoolForm school={school} onChange={setSchool} />
			</Paper>

			<Stack justifyContent="space-between">
				<Box></Box>
				<Button variant="contained" color="primary" sx={{ mt: 4 }} onClick={() => saveSchool()}>Next</Button>
			</Stack>
		</React.Fragment>
	);
}